import React, { createContext, useState, useContext } from "react";
import {BASE_URL} from '../config/apiConfig';

const ForgetPasswordContext = createContext();

export const ForgetPasswordProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState(null);
  const [resetToken, setResetToken] = useState(null);

  // Step 1: Forgot Password (Send OTP)
  const forgotPassword = async (email) => {
    try {
      const res = await fetch(`${BASE_URL}/forget-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (data.status === 200) {
        setUserEmail(email);
      }

      return data;
    } catch (error) {
      console.error("Forgot Password Error:", error);
      return { status: 500, message: "Network error. Please try again later." };
    }
  };

  // Step 2: Verify OTP
  const verifyOtp = async (otp) => {
    try {
      const res = await fetch(`${BASE_URL}/otp-verification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: userEmail, otp }),
      });

      const data = await res.json();

      if (data.status === 200 && data.reset_token) {
        setResetToken(data.reset_token);
      }

      return data;
    } catch (error) {
      console.error("OTP Verification Error:", error);
      return { status: 500, message: "Network error. Please try again later." };
    }
  };

  // Step 3: Reset Password
  const resetPassword = async (token, password) => {
    if (!token || !resetToken) {
      return {
        status: 400,
        message: "Missing token or password",
      };
    }

    try {
      const res = await fetch(`${BASE_URL}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: token,
          password: password,
        }),
      });

      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Reset Password Error:", error);
      return { status: 500, message: "Network error. Please try again later." };
    }
  };

  return (
    <ForgetPasswordContext.Provider
      value={{
        userEmail,
        resetToken,
        forgotPassword,
        verifyOtp,
        resetPassword,
      }}
    >
      {children}
    </ForgetPasswordContext.Provider>
  );
};

export const useForgetPassword = () => useContext(ForgetPasswordContext);
